module.exports = __webpack_public_path__ + "images/emoji/hammer.4c1299898fd794d4bec6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hammer.png
// module id = aKqC
// module chunks = 24